export default function MockDashboard() {
  return (
    <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-50">
      <div className="aspect-[3/2] w-full">
        <img
          src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/c6cbd6e7456bc42bac8ac4376e9bed8a.png"
          alt="Painel de resultados da campanha com participantes, resgates, evolução e distribuição por canal"
          title="Dashboard de resultados de campanha de incentivo"
          className="h-full w-full object-contain"
        />
      </div>
    </div>
  );
}